import { useEffect, useState } from 'react';
import { ResetPasswordForm } from '../components/forms/ResetPassword/ResetPasswordForm';
import { useLocation, useNavigate } from 'react-router-dom';
import checkIcon from '../assets/check-circle-icon.svg';
import { AuthBackgroundLayout } from '../layout/AuthBackgroundLayout';
import { PrimaryButton } from '../components/ui/Button/Buttons';
import { PATHS } from '../constants/Paths.constants';
import Loader from '../components/ui/Loader/Loader';
import { Background } from '../components/layout/Background';
import { useAppDispatch } from '../hooks/redux';
import { authService } from '../services/AuthService';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const tokenFromUrl = new URLSearchParams(location.search).get('token') || '';
  const emailFromUrl = new URLSearchParams(location.search).get('email') || '';

  const [isSent, setIsSent] = useState(false);
  const [verifingResetToken, setVerifyingResetToken] = useState(true);
  const [email, setEmail] = useState('');
  const [verificationToken, setVerificationToken] = useState('');

  useEffect(() => {
    if (!tokenFromUrl || !emailFromUrl) {
      navigate(PATHS.EXPIRED_LINK, {
        replace: true,
        state: { from: 'resetPassword' }
      });
      return;
    }

    const verifyToken = async () => {
      setVerifyingResetToken(true);
      try {
        const response = await authService.verifyResetToken({
          email: emailFromUrl,
          token: tokenFromUrl
        });
        setEmail(emailFromUrl);
        setVerificationToken(response.verificationToken);
        setVerifyingResetToken(false);
      } catch (error: any) {
        if (error?.status === 410) {
          navigate(PATHS.EXPIRED_LINK, {
            replace: true,
            state: { from: 'resetPassword' }
          });
          return;
        }

        setVerificationToken('');
        setVerifyingResetToken(false);
      }
    };

    verifyToken();
  }, [tokenFromUrl, emailFromUrl, navigate, dispatch]);

  if (verifingResetToken) {
    return (
      <>
        <Background />
        <div className="flex w-screen h-screen justify-center items-center">
          <Loader />
        </div>
      </>
    );
  }

  return (
    <div className="h-screen flex items-center justify-center">
      <AuthBackgroundLayout>
        {isSent ? (
          <>
            <img
              src={checkIcon}
              alt="check"
              className="w-12 h-12 self-center"
            />
            <p className="text-2xl text-purple-900 font-bold text-left self-stretch">
              Password Reset Successful
            </p>
            <p className="text-base font-normal text-gray-950 text-left self-stretch">
              Your new password has been changed successfully
            </p>
            <PrimaryButton
              onClick={() => {
                navigate(PATHS.LOGIN);
              }}
              className="w-full"
            >
              Continue to Login
            </PrimaryButton>
          </>
        ) : (
          <>
            <p className="text-2xl text-purple-900 font-bold text-left self-stretch">
              Create New Password
            </p>
            <ResetPasswordForm
              setIsSent={setIsSent}
              email={email}
              verificationToken={verificationToken}
            />
          </>
        )}
      </AuthBackgroundLayout>
    </div>
  );
}
